var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrintIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    xmlSpace: "preserve",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA5UlEQVR4nO3YTQrCMBCG4W/VS1iva+t9pO6bq7S9xoiQhZigie3kz++FWRbmoVMQAVZ3knjUag6inRASGCGRCSGBERKZEBIYIZEJIQA6AFcAW4bfVLGzAhjtzk5jAQtK5Aw+SA1vQt5m+3SXtY1T7oWahtwAnAD0AKaaIf3LfmdCkH8mi3ki7jVDJGAIkcLGKfdChPCNQD8hBITAHHDnphXIXAJEI9mzy1ohZPE9PCQ8LXMQ5OJ7uLOYNQFk3glZLML7d1BIqU9LraYh5ofT+vbNSK2QuQSIRkLIv0Ik0ajVDIRBuQev23guS+lbLQAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIconPdf);
export default __webpack_public_path__ + "static/media/print_icon_pdf.478a5a6440662a518ae729e631831966.svg";
export { ForwardRef as ReactComponent };